import { BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable()
export class menuService {
  currentNameSubject = new BehaviorSubject('route');
  toggleSideMenu = new BehaviorSubject(false);

  constructor() {}

  routeChange(data) {
    this.currentNameSubject.next(data);
  }

  toggleSidebar(val) {
    this.toggleSideMenu.next(val);
  }
}
